// extracted by mini-css-extract-plugin
export var columns1 = "FactSheetList-module--columns1--d80b3";
export var columns2 = "FactSheetList-module--columns2--3b0c6";
export var columns4 = "FactSheetList-module--columns4--c5313";
export var condense = "FactSheetList-module--condense--da0b6";
export var fact = "FactSheetList-module--fact--3dfc1";
export var facts = "FactSheetList-module--facts--0acc9";